/**
 * Map a number from one interval to another
 * @param from Map from this interval
 * @param to Map to this interval
 * @param value Map this value
 */
export function mapRange(from: [number, number], to: [number, number], value: number) {
  return to[0] + ((value - from[0]) * (to[1] - to[0])) / (from[1] - from[0]);
}
